<template>
	<transition name="modal-fade">
		<div class="modal-backdrop">
			<div class="modal">
				<header class="modal-header" :class="(famille)?'famille':'header'" >
					<slot name="header ">
						<div class="symbol" v-if="famille">
							<img :src="famille.img" alt="">
						
						</div>
						<h2 >{{headerTitle}}<h4 v-if="famille">{{famille.name}}</h4></h2>
						
						
						<button
								type="button"
								class="btn-close"
								@click="close"
						>
							x
						</button>
					</slot>
				</header>
				<section class="modal-body">
					<slot name="body">
						<div class="symbol" v-if="!famille">
							<img src="../assets/logo.png" alt="">
						
						</div>
						<div class="famille" v-if="famille">
							<div class="box" v-for="(link,key) in links" :key="key">
								<div class="img">
									<img :src="link.img" alt="">
								</div>
								<div class="text">
									<h2>{{link.name}}</h2>
									<span>{{link.role}}</span>
								</div>
							</div>
						</div>
						<div class="links" v-else>
							<ul>
								<li v-for="(link,key) in links" :key="key">
									{{link}}
								</li>
							</ul>
						</div>
						
						<div class="personnage" v-if="!famille">
							<img src="../assets/logo.png" alt="">
						
						</div>
					</slot>
				</section>
				<footer class="modal-footer" v-if="!famille">
					<slot name="footer">
						
						<button
								type="button"
								class="btn-green"
								@click="close"
						>
							Valider
						</button>
					</slot>
				</footer>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'modal',
		props: [
			"headerTitle",
			"bodyText",
			"famille",
		],
		data() {
			return {
				links: this.bodyText
				
			}
		},
		mounted() {
			
			this.links = this.bodyText
		},
		updated() {
			this.links = this.bodyText
		},
		methods: {
			close() {
				this.$emit('close');
			},
			onScroll(evt,el){
				// console.log(document.querySelector(".modal").scrollTop)
				if (document.querySelector(".modal").scrollTop > 50) {
					el.setAttribute(
						'style',
						'position: fixed;background:white;'
					)
				}else{
					el.setAttribute(
						'style',
						'position: initial;'
					)
				}
				
			}
		},
	};
</script>


<style lang="scss" scoped>
	.modal-backdrop {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.modal {
		position:relative;
		background: rgb(23, 23, 23);
		box-shadow: 2px 2px 20px 1px grey;
		border:2px solid black;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		max-width: 70vw;
		min-width: 70vw;
		max-height: 75vh;
		min-height: 75vh;
		
	}
	
	.modal-header,
	.modal-footer {
		padding: 15px;
		display: flex;
	}
	
	.modal-header {
		border-bottom: 1px solid black;
		color: #fff;
		/*justify-content: space-between;*/
		padding: 0;
		z-index: 1000;
		
		h2 {
			margin: auto;
		}
		
		.symbol {
			flex: 1;
			
			img {
				width: 100%;
			}
		}
	}
	
	.modal-header.famille {
		background:rgb(23, 23, 23);
		h2 {
			flex: 5;
			margin: auto;
		}
	}
	
	.modal-footer {
		/*border-top: 1px solid #eeeeee;*/
		justify-content: center;
		
		button {
			cursor:pointer;
			padding: 10px 20px;
		}
	}
	
	.modal-body {
		/*position: absolute;*/
		overflow-x: auto;
		left:0;right:0;
		bottom:0;
		top:150px;
		padding: 20px 10px;
	}
	
	.btn-close {
		border: none;
		font-size: 20px;
		padding: 20px;
		cursor: pointer;
		font-weight: bold;
		color: #fff;
		background: transparent;
	}
	
	.btn-green {
		color: black;
		background: #9b9b9b;
		border-radius: 2px;
		border:none;
		transition:.3s;
	}
	.btn-green:hover {
		color: white;
		background: black;
	}
	
	.modal-fade-enter,
	.modal-fade-leave-active {
		opacity: 0;
	}
	
	.modal-fade-enter-active,
	.modal-fade-leave-active {
		transition: opacity .5s ease
	}
	h2{
		h4{
			margin:0;
		}
	}
	.modal-body {
		display: flex;
		justify-content: space-around;
		
		.symbol, .personnage {
			flex: 1;
			
			img {
				width: 100%;
			}
		}
		
		.links {
			flex: 2;
			margin: auto;
			color:white;
			ul {
				margin: auto;
				display: inline-block;
			}
		}
		
		.famille {
			flex: 2;
			margin: auto;
			
		}
	}

</style>